import {
  convertCkHtml,
  convertHtmlToPlainText,
  convertToEditorHtml,
} from './suneditor/convert_ck_contents';

const PREFIX = 'category_';

class CategoryTemplate {
  // container を指定すると、カテゴリ select と本文欄の探索をその要素配下に限定する
  // (誘導モーダルなど、ページ本体側のフォームを巻き込みたくない場合に使う)。
  constructor(container = document) {
    this.container = container;
    this.removeAllIem();

    const self = this;
    // research 経由の投稿 (research_answer_id 付き URL) では回答内容が本文にプリセットされ、
    // カテゴリを手動で切り替える運用があるため、切替時に本文を消さない
    // COMMUNITY-4612 以前の挙動を維持する (COMMUNITY-4680)
    const isResearchPost = new URLSearchParams(window.location.search).has(
      'research_answer_id',
    );
    const $categorySelect = $(container).find('.js-category-id');
    let categoryVal = PREFIX + $categorySelect.val();

    $categorySelect.on('change', function () {
      const type = $(this).data('type');
      const categorySelect = this;
      const requestedCategoryId = categorySelect.value;
      self.saveBody(type, categoryVal);
      categoryVal = PREFIX + requestedCategoryId;

      if (isResearchPost) {
        const savedBody = localStorage.getItem(categoryVal);
        if (savedBody) return self.setBody(type, savedBody);
        if (!requestedCategoryId) return;

        $.ajax({
          type: 'GET',
          url: `/${type}_categories/${requestedCategoryId}/template`,
          dataType: 'json',
        })
          .done(function (data) {
            if (data.body) self.setBody(type, data.body);
          })
          .fail(function (e) {
            console.error(e);
          });
        return;
      }

      if (!requestedCategoryId) return self.setBody(type, '');
      const savedBody = localStorage.getItem(categoryVal);
      if (savedBody) return self.setBody(type, savedBody);

      $.ajax({
        type: 'GET',
        url: `/${type}_categories/${requestedCategoryId}/template`,
        dataType: 'json',
      })
        .done(function (data) {
          if (categorySelect.value !== requestedCategoryId) return;
          // テンプレート未設定カテゴリでは前カテゴリの内容が残らないよう空文字で必ず反映する
          self.setBody(type, data.body || '');
        })
        .fail(function (e) {
          console.error(e);
        });
    });
  }

  isAnnouncement(type) {
    return type === 'announcement';
  }

  isChat(type) {
    return type === 'chat';
  }

  usesRichEditor(type) {
    return this.isAnnouncement(type) || this.isChat(type);
  }

  saveBody(type, key) {
    localStorage.setItem(key, this.getBody(type));
  }

  getBody(type) {
    if (this.isChat(type)) {
      const bodyFormat = $('#chat_body_format').val();
      if (bodyFormat === 'markdown') {
        return $('#chat_markdown_body').val();
      }
      if (window.suneditor) {
        return window.suneditor.getContents(true);
      }
      return $('#chat_text_body').val();
    }

    if (this.usesRichEditor(type) && window.suneditor) {
      return window.suneditor.getContents(true);
    }
    if (this.isAnnouncement(type)) {
      return editor.data.get();
    }
    return $(this.container).find('.js-category-template-body').val();
  }

  setBody(type, body) {
    if (this.isChat(type)) {
      const bodyFormat = $('#chat_body_format').val();
      $('#chat_markdown_body').val(
        bodyFormat === 'markdown' ? body : convertHtmlToPlainText(body),
      );

      if (window.suneditor) {
        window.suneditor.setContents(convertToEditorHtml(body));
      } else {
        $('#chat_text_body').val(convertHtmlToPlainText(body));
      }
      return;
    }

    if (this.usesRichEditor(type) && window.suneditor) {
      window.suneditor.setContents(convertCkHtml(body));
    } else if (this.isAnnouncement(type)) {
      editor.data.set(body);
    } else {
      $(this.container).find('.js-category-template-body').val(body);
    }
  }

  removeAllIem() {
    for (const key in localStorage) {
      if (localStorage.hasOwnProperty(key)) {
        if (key && key.indexOf(PREFIX) === 0) localStorage.removeItem(key);
      }
    }
  }
}

export { CategoryTemplate };
